export default __webpack_public_path__ + "static/media/iread5.df556df5.jpeg";